// import Aboutus from "./home/AboutUs";
// import Contact from "./home/Contact";
// import Faq from "./home/Faq";
// import Resources from "./home/Resources";
// import Services from "./home/Services";
// import Team from "./home/Team";
import HeroSection from "./home/Hero";
import Portfolio from "./home/Portfolio";
import Pricing from "./home/Pricing";
import StatsFacts from "./home/StatsFacts";
import Testimonial from "./home/Testimonial";
import PageLayout from "./PageLayout";

export default function Home() {
  return (
    <>
      <PageLayout>
        <content>
          <HeroSection />
          <Testimonial />
          <StatsFacts />
          {/* <Services /> */}
          <Portfolio />
          {/* <Aboutus /> */}
          {/* <Team teamdataNumber="06" /> */}
          <Pricing />
          {/* <Faq /> */}
          {/* <Resources /> */}
          {/* <Contact contactdataNumber="10" /> */}
        </content>
      </PageLayout>
    </>
  );
}
